export default __webpack_public_path__ + "static/media/cheetah.b8e850a0.gif";